import { Card, CardBody } from 'reactstrap';

const KpiCard = ({
    icon: Icon,
    title,
    value,
}) => (
    <Card className="h-100 mb-0 shadow-sm">
        <CardBody>
            {Icon ? (
                <Icon size={24} className="mb-3 text-primary" />
            ) : null}

            <p className="mb-2 text-muted">
                {title}
            </p>

            <h4 className="mb-0 fw-semibold">
                {value}
            </h4>
        </CardBody>
    </Card>
);

export default KpiCard;
